import React, { useEffect, useReducer } from 'react';

// Redux pieces to eventually be removed
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import PropTypes from 'prop-types';

import { trackV2 } from 'utils/analytics';
import checkoutReducer, { initCheckoutState } from './state/Checkout.reducer';
import { buildInitialCheckoutState } from './state/checkout.initial-state';
import CheckoutContext from './state/CheckoutContext';

import Form from './components/Form';
import Terms from './components/Terms';
import SummaryContainer from './components/SummaryContainer';
import styles from './index.scss';
import { analyticsDataProps, trialInfoProps } from './shared/prop-types';
import AdyenSessionAdapter from './components/AdyenSessionAdapter';

const Checkout = (props) => {
  // note: props come from checkout.rb method 'checkout_app_props'
  const { dropInSessionEnabled } = props;

  const [checkoutEntityState, dispatch] = useReducer(
    checkoutReducer,
    buildInitialCheckoutState(props),
    initCheckoutState
  );

  const providerState = {
    checkoutEntityState,
    dispatch
  };

  const store = createStore(checkoutReducer, props, applyMiddleware(thunk));

  useEffect(() => {
    trackV2({
      category: 'summit_upsell',
      page: 'cart',
      action: 'screen_enter',
      properties: { ...props.analytics_data }
    });
  }, []);

  return (
    <Provider store={store}>
      <CheckoutContext.Provider value={providerState}>
        <>
          <div className={styles.container}>
            <SummaryContainer />
            {dropInSessionEnabled ? <AdyenSessionAdapter /> : <Form />}
          </div>
          <Terms />
        </>
      </CheckoutContext.Provider>
    </Provider>
  );
};

Checkout.propTypes = {
  analytics_data: analyticsDataProps.isRequired,
  dropInSessionEnabled: PropTypes.bool.isRequired
};

CheckoutContext.Provider.propTypes = {
  value: PropTypes.shape({
    checkoutEntityState: PropTypes.shape({
      adyenClientPubkey: PropTypes.string,
      analyticsData: analyticsDataProps.isRequired,
      checkoutError: PropTypes.bool.isRequired,
      checkoutSubmitting: PropTypes.bool.isRequired,
      checkoutSuccess: PropTypes.bool.isRequired,
      checkoutSuccessRedirectPath: PropTypes.string.isRequired,
      clientKey: PropTypes.string,
      currency: PropTypes.string.isRequired,
      duration: PropTypes.string.isRequired,
      environment: PropTypes.string.isRequired,
      experiments: PropTypes.object.isRequired,
      isStudentPromotion: PropTypes.bool.isRequired,
      isTrial: PropTypes.bool.isRequired,
      isTrialEligible: PropTypes.bool.isRequired,
      packageIds: PropTypes.arrayOf(PropTypes.number),
      products: PropTypes.shape({
        monthly: PropTypes.shape({
          recurringAmount: PropTypes.number,
          priceWithoutDiscount: PropTypes.number
        }),
        promotion: PropTypes.shape({
          full: PropTypes.bool,
          code: PropTypes.string
        }),
        yearly: PropTypes.shape({
          recurringAmount: PropTypes.number,
          priceWithoutDiscount: PropTypes.number
        })
      }),
      promoCampaign: PropTypes.bool,
      promoCodeError: PropTypes.bool.isRequired,
      promoCodeInputVisibility: PropTypes.bool.isRequired,
      promoCodeSubmitting: PropTypes.bool.isRequired,
      sessionData: PropTypes.string,
      sessionEnabled: PropTypes.bool.isRequired,
      sessionId: PropTypes.string,
      showPaypal: PropTypes.bool,
      trialInfo: trialInfoProps,
      yearlyPercentOff: PropTypes.number
    }),
    dispatch: PropTypes.func.isRequired
  })
};

export default Checkout;
